import React from "react";
import {
  ExpandableContainerView,
  useExpandableList,
} from "@bloomberg/media-ui-markets";
import styles from "./topHoldings.module.css";
import type { TopHolding } from "~types/types";
import { TranslatedMessage, useTranslateMessage } from "~utils/i18n";

type TopHoldingsProps = { topHoldings: TopHolding[] };

const TOP_HOLDINGS_TO_DISPLAY = 6;

export default function TopHoldings({ topHoldings }: TopHoldingsProps) {
  const {
    isExpandable,
    isExpanded,
    toggleExpanded,
    displayedList: displayedTopHoldings,
  } = useExpandableList<TopHolding>(topHoldings, TOP_HOLDINGS_TO_DISPLAY);

  const translateMessage = useTranslateMessage();
  const topHoldingsLabel = translateMessage({
    id: "topHoldings",
    defaultMessage: "Top Holdings",
  });

  const viewMoreLabel = translateMessage({
    id: "viewMore",
    defaultMessage: "View More",
  });

  return (
    <ExpandableContainerView
      className={styles.topHoldingsContainer}
      containerTitle={topHoldingsLabel}
      handleClick={toggleExpanded}
      isExpanded={isExpanded}
      isExpandable={isExpandable}
      expandButtonText={viewMoreLabel}
    >
      <table className={styles.topHoldings}>
        <thead>
          <th className={styles.columnHeader}>
            <TranslatedMessage id={"name"} defaultMessage={"Name"} />
          </th>
          <th className={styles.columnHeader}>
            <TranslatedMessage id={"position"} defaultMessage={"Position"} />
          </th>
          <th className={styles.columnHeader}>
            <TranslatedMessage id={"value"} defaultMessage={"Value"} />
          </th>
          <th className={styles.columnHeader}>
            <TranslatedMessage
              id={"percentOfFund"}
              defaultMessage={"% of Fund"}
            />
          </th>
        </thead>
        <tbody>
          {displayedTopHoldings.map(
            ({ name, security, value, position, percentOfFund }) => (
              <tr className={styles.holding} key={security}>
                <td className={styles.columnItem}>
                  <span className={styles.securityName}>{name}</span>
                  <span className={styles.security}>{security}</span>
                </td>
                <td className={styles.columnItem}>{position}</td>
                <td className={styles.columnItem}>{value}</td>
                <td className={styles.columnItem}>{percentOfFund}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </ExpandableContainerView>
  );
}
